module.exports = __webpack_public_path__ + "static/media/icon-close.869badc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-close.svg
// module id = 1110
// module chunks = 0